class IFRStoryV2 {
    bookmark;
    date;
    headline;
    id;
    path;
    updatedDate;
    constructor(response) {
        this.bookmark = response.bookmark;
        this.date = new Date(response.date);
        this.headline = response.headline;
        this.id = response.id;
        this.path = response.path;
        this.updatedDate = new Date(response.updatedDate);
    }
}
export default IFRStoryV2;
